import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { FC } from "react";
import DOMPurify from "dompurify";
import { LandingPageCard as Card } from "../components";

DOMPurify.addHook("afterSanitizeAttributes", (node: Element) => {
  // set all elements owning target to target=_blank
  // eslint-disable-next-line no-prototype-builtins
  if (Object.getPrototypeOf(node).hasOwnProperty("target")) {
    node.setAttribute("target", "_blank");
  }

  // set non-HTML/MathML links to xlink:show=new
  if (
    !node.hasAttribute("target") &&
    (node.hasAttribute("xlink:href") || node.hasAttribute("href"))
  ) {
    node.setAttribute("xlink:show", "new");
  }
});

export type EventDescriptionProps = {
  description: string;
};

const EventDescription: FC<EventDescriptionProps> = ({ description }) => (
  <Card size="md" elevation={0}>
    <Typography
      variant="body1"
      color="textSecondary"
      style={{
        wordBreak: "break-word",
      }}
    >
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(description),
        }}
      />
    </Typography>
  </Card>
);

export default EventDescription;
